import { anEntityInterface } from '__generated__';
import { delay, HttpResponse } from 'msw';

import { mockEntityAuditLogQueryOperationQuery } from '@sbu/views.entityauditlog/build/mocks';

export const handlers = [
  mockEntityAuditLogQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          entity: anEntityInterface(),
        },
      });
    }
  ),
];
